import { GalleryDto } from '@picflow/types';
import { randomString } from '../lib/random-string';

export type UploadObjError = 'general' | 'invalid-file-type' | 'cancelled' | 'cant-read-file';
export class UploadObj {
  file: File;
  imageSrc: string; // used as preview instead of trying to auto generate a preview
  status: 'waiting' | 'started' | 'processing' | 'done' | 'error' = 'waiting';
  error: UploadObjError;
  progress = 0;
  galleryId: string;
  gallery: GalleryDto;
  sectionId: string;
  startTime: number;
  endTime: number;
  position: number;
  cancelled = false;
  description?: string;
  id = randomString(12);

  constructor(file: File, gallery: GalleryDto, sectionId?: string, position?: number) {
    this.file = file;
    this.galleryId = gallery.id;
    this.gallery = gallery;
    this.sectionId = sectionId;
    this.position = position;
  }
}
